import React from "react";
import { WocommCategoriesUIProvider } from "./WocommCategoriesUIContext";
import WocommCategoriesCard from "./WocommCategories";


export function WocommCategoriesPage({ history }) {

  const wocommCategoriesUIEvents = {
  
    openEditWocommCategoryPage: (id, total) => {
      history.push(`/app/woocommerce-categories/${id}/${total}/edit`);
    },

    openViewWocommCategoryPage: (id) => {
      history.push(`/app/woocommerce-categories/${id}/view`);
    },
   
  };
  
  return (
    <WocommCategoriesUIProvider wocommCategoriesUIEvents={wocommCategoriesUIEvents}>
     
      <WocommCategoriesCard />
    </WocommCategoriesUIProvider>
  );
}
